import { render, staticRenderFns } from "./TemplateApproval.vue?vue&type=template&id=728c364c&scoped=true&"
import script from "./TemplateApproval.vue?vue&type=script&lang=js&"
export * from "./TemplateApproval.vue?vue&type=script&lang=js&"
import style0 from "./TemplateApproval.vue?vue&type=style&index=0&id=728c364c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c364c",
  null
  
)

component.options.__file = "TemplateApproval.vue"
export default component.exports